import { createReducer } from '@reduxjs/toolkit';
import { ProjectShape } from './model';
import * as projectActions from './actions';
import * as lastStateActions from '../lastState/actions';

const initial: ProjectShape = {
  projects: [],
  selectedIds: [],
  loading: false,
  expanded: true,
};

export const projectReducer = createReducer<ProjectShape>(initial, (builder) =>
  builder
    .addCase(projectActions.projectsChanged, (s, a) => {
      s.projects = a.payload.projects;
    })
    .addCase(projectActions.projectIdsSelected, (s, a) => {
      s.selectedIds = a.payload.ids;
    })
    .addCase(projectActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(projectActions.expandedChanged, (s, a) => {
      s.expanded = a.payload.expanded;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      s.selectedIds = a.payload?.state.data.project.selectedIds ?? initial.selectedIds;
      s.expanded = a.payload?.state.data.project?.expanded ?? initial.expanded;
    }),
);
